import { AdFarmApiClient } from "./AdFarmApiClient";
import { MobileRole, PayoutAccountInput } from "./AdFarmTypes";

export class PayoutRepository {
    constructor(private readonly api: AdFarmApiClient) {}

    saveAccount(role: MobileRole, input: PayoutAccountInput): Promise<unknown> {
        if (!input.payeeName.trim()) throw new Error("请输入支付宝实名姓名");
        if (!input.payoutIdentity.trim()) throw new Error("请输入支付宝收款账号");
        return this.api.savePayoutAccount(role, input);
    }

    submitWithdrawal(role: MobileRole): Promise<unknown> {
        return this.api.submitWithdrawal(role);
    }
}
